import { singleAccordianHandler } from "./accordianTypes/singleAccordian.js";
import { groupedAccordianHandler } from "./accordianTypes/groupedAccordians.js";

function accordiansJS() {
    // Clean up existing event listeners
    document.removeEventListener('dynamicContentLoaded', accordiansJS);

    const accordians = Array.from(document.querySelectorAll('[data-accordian]'));
    if (!accordians.length) return;

    const groupOfAccordians = document.querySelectorAll('[data-accordianGroup]');
    const singleAcccordians = accordians.filter(accordian => !accordian.parentElement.matches('[data-accordianGroup]'));

    // Clean up existing listeners before setting new ones
    accordians.forEach(accordion => {
        if (accordion._clickHandler) {
            accordion.removeEventListener('click', accordion._clickHandler);
        }
    });

    groupOfAccordians.forEach(group => {
        if (group._clickHandler) {
            group.removeEventListener('click', group._clickHandler);
        }
    });

    // Set the intial attributes for ALL accordians
    accordians.forEach((accordian, index) => {
        const accordianTitle = accordian.querySelector('[data-accordianTitle]');
        const accordianContent = accordian.querySelector('[data-accordianContent]');
        if (accordianTitle && accordianContent) {
            const uniqueId = `accordion${index}_${Date.now()}`;
            accordianTitle.setAttribute('id', uniqueId);
            accordianContent.setAttribute('aria-labelledby', uniqueId);
        }
    });


    // Check if the accordian is active and update the class
    const toggleAccordianState = (accordianButton, accordian, isActive) => {
        if (!isActive) {
            accordian.classList.add("accordianIsActive");
            accordianButton.setAttribute('aria-expanded', `true`);
        } else {
            accordian.classList.remove('accordianIsActive');
            accordianButton.setAttribute('aria-expanded', `false`); 
        }
    }
    
    //=====================================================================
    // Handlers for the different accordian Types
    //=====================================================================
    groupedAccordianHandler(groupOfAccordians, toggleAccordianState);
    singleAccordianHandler(singleAcccordians, toggleAccordianState);

    // Add single event listener for dynamic content
    document.addEventListener('dynamicContentLoaded', accordiansJS);
}

// Self-invoke the function
accordiansJS();

// Export the function for potential use in other files
export { accordiansJS };